import React, { Component } from 'react';
import Faq from "react-faq-component";
import Grid from "@material-ui/core/Grid";
import { data } from '../QuestionsBeforeYouDiveIn/data';

import './style.scss';

class QuestionsBeforeYouDiveIn extends Component {
  render() {
    return (
      <Grid container justify={'center'} className="UsWrapper" >
        <Grid item xs={10}> 
          <Faq className="faq" data={data} />
        </Grid>
      </Grid>
    );
  };
};

export default QuestionsBeforeYouDiveIn;